<template>
  <div>
    <div v-for="(masterbooks, key) in masterBooksForEachAreas" :key="key">
      <div class="index">
        <ItemAccordion
          v-if="key != 'done'"
          :master_books="masterbooks"
          :area="key"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TemplateTicketStoreIndex",
  props: {
    masterBooksForEachAreas: { type: Object, required: true },
  },
};
</script>

<style scoped lang="scss">
.index {
  position: relative;
}
</style>
